// Bluetooth thermal printer helper using Web Bluetooth API + ESC/POS commands
// Works on Chrome desktop/Android for most 58/80mm thermal printers with SPP-like GATT service.

const SERVICES = [
  '000018f0-0000-1000-8000-00805f9b34fb', // common thermal printer service
  '49535343-fe7d-4ae5-8fa9-9fafd205e455', // ISSC/JDY-33
  '0000ff00-0000-1000-8000-00805f9b34fb',
];

const CHARACTERISTICS = [
  '00002af1-0000-1000-8000-00805f9b34fb',
  '49535343-8841-43f4-a8d4-ecbe34729bb3',
  '0000ff02-0000-1000-8000-00805f9b34fb',
];

function textEncoder() { return new TextEncoder(); }

function escPosLine(text) {
  return textEncoder().encode(text + '\n');
}

function fmtIDR(n) { return 'Rp ' + Math.round(n).toLocaleString('id-ID'); }

function buildReceipt(tx) {
  const enc = textEncoder();
  const chunks = [];
  // Init printer
  chunks.push(new Uint8Array([0x1B, 0x40])); // ESC @ reset
  chunks.push(new Uint8Array([0x1B, 0x61, 0x01])); // center
  chunks.push(new Uint8Array([0x1B, 0x21, 0x30])); // double h+w
  chunks.push(escPosLine('ERP ZAINUSA POS'));
  chunks.push(new Uint8Array([0x1B, 0x21, 0x00]));
  chunks.push(escPosLine('Struk Penjualan'));
  chunks.push(escPosLine('--------------------------------'));
  chunks.push(new Uint8Array([0x1B, 0x61, 0x00])); // left
  chunks.push(escPosLine(`No  : ${tx.invoice_no}`));
  chunks.push(escPosLine(`Tgl : ${(tx.created_at || '').slice(0, 19).replace('T', ' ')}`));
  chunks.push(escPosLine(`Ksr : ${tx.created_by_name || '-'}`));
  chunks.push(escPosLine(`Sls : ${tx.salesman_name || '-'}`));
  if (tx.customer_name) chunks.push(escPosLine(`Plgn: ${tx.customer_name}`));
  chunks.push(escPosLine('--------------------------------'));
  for (const it of (tx.items || [])) {
    chunks.push(escPosLine(it.name.slice(0, 32)));
    const line = ` ${it.quantity} x ${fmtIDR(it.unit_price)}`.padEnd(20) + fmtIDR(it.subtotal).padStart(12);
    chunks.push(escPosLine(line));
  }
  chunks.push(escPosLine('--------------------------------'));
  chunks.push(new Uint8Array([0x1B, 0x21, 0x10])); // double height
  chunks.push(escPosLine('TOTAL: ' + fmtIDR(tx.total)));
  chunks.push(new Uint8Array([0x1B, 0x21, 0x00]));
  chunks.push(escPosLine('Bayar: ' + (tx.payment_method || '').toUpperCase() + (tx.payment_reference ? ` (${tx.payment_reference})` : '')));
  chunks.push(escPosLine(''));
  chunks.push(new Uint8Array([0x1B, 0x61, 0x01]));
  chunks.push(escPosLine('Terima kasih!'));
  chunks.push(escPosLine(''));
  chunks.push(escPosLine(''));
  chunks.push(escPosLine(''));
  chunks.push(new Uint8Array([0x1D, 0x56, 0x00])); // full cut
  // Concatenate
  const totalLen = chunks.reduce((a, c) => a + c.byteLength, 0);
  const buf = new Uint8Array(totalLen);
  let o = 0;
  for (const c of chunks) { buf.set(c, o); o += c.byteLength; }
  return buf;
}

export async function printReceiptBluetooth(tx) {
  if (!('bluetooth' in navigator)) {
    throw new Error('Web Bluetooth tidak didukung browser ini');
  }
  const device = await navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: SERVICES,
  });
  const server = await device.gatt.connect();
  let characteristic = null;
  for (const svcUuid of SERVICES) {
    try {
      const service = await server.getPrimaryService(svcUuid);
      const chars = await service.getCharacteristics();
      for (const c of chars) {
        if (c.properties.writeWithoutResponse || c.properties.write) {
          characteristic = c;
          break;
        }
      }
      if (characteristic) break;
    } catch (e) { console.debug('[bluetoothPrint] service probe failed', svcUuid, e); /* try next */ }
  }
  if (!characteristic) {
    server.disconnect();
    throw new Error('Karakteristik tulis tidak ditemukan');
  }

  const data = buildReceipt(tx);
  // Send in chunks of 20 bytes for BLE
  const chunkSize = 100;
  for (let i = 0; i < data.length; i += chunkSize) {
    const chunk = data.slice(i, i + chunkSize);
    if (characteristic.properties.writeWithoutResponse) {
      await characteristic.writeValueWithoutResponse(chunk);
    } else {
      await characteristic.writeValue(chunk);
    }
    await new Promise((r) => setTimeout(r, 30));
  }
  server.disconnect();
}
